import Vue from 'vue';
import axios from 'axios';
import 'normalize.css';
import '@/assets/iconfont/iconfont.css';
import utils from '@/services/utils';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';
import './plugins/element';
import './styles/global.scss';

Vue.http = axios.create({
  timeout: 10 * 1000,
  withCredentials: false,
});

axios.defaults.headers.common.Authorization = utils.storage('token') || '';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
